import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step192329Meta extends BaseModel {
  nextOfKinRelationship?: string;

  constructor(model: Partial<Step192329Meta> = {}) {
    super();

    this.nextOfKinRelationship = model.nextOfKinRelationship;
  }
}
